import Axios from '@/components/api/axios.js'

export default {
    // 获取列表
    getList: (pageIndex, pageSize, name, date, success, failure) => {
        Axios.post('/manufacturingKanban/getList', {
            pageIndex,
            pageSize,
            name,
            date
        }, success, failure)
    },

    add: (manufactringKanban, success, failure) => {
        Axios.post('/manufacturingKanban/add',
            manufactringKanban, success, failure)
    },

    update: (jsonString, success, failure) => {
        Axios.post('/manufacturingKanban/update',
            { jsonString }, success, failure)
    },

    getListByNames: (names, date, success, failure) => {
        Axios.post('/manufacturingKanban/findByNamesAndYear',
            { names, date }, success, failure)
    }
}